export const SECURITY_CARD_COLUMNS = [
    { Header: "Justification", accessor: "justification", thClassName: "text-center", tdClassName: "text-center" },
    { Header: "Updated By", accessor: "updatedBy", thClassName: "text-center", tdClassName: "text-center" },
    { Header: "Updated On", accessor: "updatedOn", thClassName: "text-center", tdClassName: "text-center" },
];

export const CIS_BENCHMARK_EXCLUSION_LABELS = {
    createTitle: 'Create CIS Benchmark Exclusion',
    editTitle: 'Update CIS Benchmark Exclusion',
    nameLabel: 'Control Type',
    namePlaceholder: 'e.g., Database',
    nameError: 'Control Type is required',
    availableLabel: 'Select Audit File',
    selectedLabel: 'Selected Audit File(s)',
    selectedError: 'At least one audit file must be selected',
    availableEmpty: 'No available files',
    selectedEmpty: 'No audit files have been selected',
    keywordsLabel: 'Rules to Exclude',
};
